export const changeCodeDicData = [
	{
		label: '投保',
		value: 100,
	},
	{
		label: '新增雇员',
		value: 101,
	},
	{
		label: '退保',
		value: 201,
	},
	{
		label: '线下新增',
		value: 801,
	},
	{
		label: '批减人员',
		value: 803,
	},
	{
		label: '批改工种',
		value: 804,
	},
]

export const policyStatusDicData = [
	{
		label: '退保',
		value: 0,
	},
	{
		label: '保障中',
		value: 3,
	},
	{
		label: '已失效',
		value: 5,
	},
	{
		label: '已支付',
		value: 7,
	},
]

export const settleStatusDicData = [
	{
		label: '未结算',
		value: 0,
	},
	{
		label: '结算中',
		value: 1,
	},
	{
		label: '已结算',
		value: 2,
	},
]

//状态，
//CREATED待处理，CANCELED已撤销，REJECTED_FIRST初审驳回，
// APPROVED_FIRST上级复审，REJECTED_FINAL复审驳回，
// APPROVED_FINAL复审通过，COMMITTED_FINANCE提交财务处理，REMITTED已打款
export const applySettleDicData = [
	{
		label: '待处理',
		value: 'CREATED',
	},
	{
		label: '已撤销',
		value: 'CANCELED',
	},
	{
		label: '初审驳回',
		value: 'REJECTED_FIRST',
	},
	{
		label: '初审通过,待上级复审',
		value: 'APPROVED_FIRST',
	},
	{
		label: '被驳回,重新审核',
		value: 'REJECTED_FINAL',
	},
	{
		label: '复审通过,待财务处理',
		value: 'APPROVED_FINAL',
	},
	{
		label: '财务已处理,等待打款',
		value: 'COMMITTED_FINANCE',
	},
	{
		label: '已打款',
		value: 'REMITTED',
	},
]

export const fontApplySettleDicData = [
	{
		label: '待处理',
		value: 'ING',
	},
	{
		label: '已撤销',
		value: 'CANCELED',
	},
	{
		label: '被驳回',
		value: 'REJECTED_FIRST',
	},
	{
		label: '审核中',
		value: 'APPROVED_FIRST',
	},
	{
		label: '审核中',
		value: 'REJECTED_FINAL',
	},
	{
		label: '审核完成，待打款',
		value: 'APPROVED_FINAL',
	},
	{
		label: '审核完成，待打款',
		value: 'COMMITTED_FINANCE',
	},
	{
		label: '已打款',
		value: 'REMITTED',
	},
]

//档次
export const feeRateDicData = [
	{
		label: '1档',
		value: 1,
	},
	{
		label: '2档',
		value: 1.1,
	},
	{
		label: '3档',
		value: 1.15,
	},
	{
		label: '--',
		value: 0,
	},
]

//异常状态 取消状态，-2已退回，-1待核算，0未取消（已核算），1退保中取消，2已退保取消，3主保单未结算取消
export const cancelStatusDicData = [
	{
		label: '已退回',
		value: -2,
	},
	{
		label: '待核算',
		value: -1,
	},
	{
		label: '已核算',
		value: 0,
	},

	// ,{
	//     label: '退保中取消',
	//     value: 1,
	// },{
	//     label: '已退保取消',
	//     value: 2,
	// },{
	//     label: '主保单未结算取消',
	//     value: 3,
	// }
]

//批单管理选项
export const changeCodeDicEndorseData = [
	{
		label: '批增',
		value: 101,
	},
	{
		label: '替换',
		value: 102,
	},
	{
		label: '退保',
		value: 201,
	},
	{
		label: '线下新增',
		value: 801,
	},
	{
		label: '批减人员',
		value: 803,
	},
	{
		label: '批改工种',
		value: 804,
	},
]
